import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

export const typeColumnConfig = <T extends TableRow>(
  options?: Omit<TableColumn<T>, 'id' | 'label'>,
): TableColumn<T> => ({
  id: 'type',
  label: <Trans i18nKey="type" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">{value}</div>
  ),
  acessorKey: 'costType',
  sortable: true,
  align: 'left',
  alignHeader: 'left',
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
